import styled, { css } from 'styled-components';
import Dropdown from '@prisjakt/ui-dropdown';
import ButtonComponent from '@prisjakt/ui-button';
import { media, remCalc } from '@prisjakt/ui-base';
import TooltipComponent from '@prisjakt/ui-tooltip-new';
import { actionButton } from '../../constants';

const marginBottom = `${remCalc(8)}`;

export const ActionButton = styled.div`
  flex: 0 0 32%;

  ${media.smallOnly`
    margin-bottom: ${marginBottom};
  `}

  ${props =>
    props.buttonStyle === 'circle' &&
    css`
      flex: none;
    `}
`;

export const Button = styled(ButtonComponent)`
  margin: 0;
  padding: 8px 4px 8px 8px;
  overflow: hidden;
  width: 100%;
  ${p =>
    p.buttonStyle === 'circle' &&
    css`
      padding: 0;
      width: ${remCalc(50)};
      height: ${remCalc(50)};
      margin-right: ${remCalc(10)};
    `}
`;

export const Tooltip = styled(TooltipComponent).attrs({ minWidth: '180px' })`
  z-index: 3;
`;

export const ProductActionButtons = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(3, 32%);
  grid-column-gap: ${actionButton.buttonMarginMobile};
  ${media.mediumUp`
  margin-bottom: ${remCalc(8)};
  `}

  .ui-dropdown--toggle-button,
  .ui-dropdown--header {
    width: 100%;
    padding: 0;
  }

  .ui-dropdown--title:not(:empty) {
    width: 100%;
    padding: 0;
  }

  ${props =>
    !props.horizontal &&
    css`
      flex-direction: column;
      grid-template-columns: ${actionButton.buttonWidthVal}px;
    `}

  ${props =>
    props.buttonStyle === 'circle' &&
    css`
      display: flex;
      justify-content: flex-start;
    `}
`;

export const ButtonText = styled.div.attrs({ 'data-test': 'ButtonText' })`
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${media.mediumDown`
    display: none;
  `}
`;

export const ListsDropdown = styled(Dropdown)``;
